import { Component, HostListener, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { ECallScriptRoutes, ECallScriptSections } from '../enum';

@Component({
    selector: 'app-call-script',
    templateUrl: './call-script.component.html',
    styleUrls: ['./call-script.component.scss'],
    standalone: false
})
export class CallScriptComponent implements OnInit {

  selectedRoute = ECallScriptRoutes.Inbound;
  currentScript = null;
  routes = [];
  prospectTypes = [];
  sections = [];
  isFirstScript = false;
  isLastScript = false;
  @Input() section = ECallScriptSections.Prospect;
  currentType = ECallScriptSections.Prospect;
  @Input() isScreenPopup = false;

  constructor(private facOpsDataService: FacOpsDataService,
    public generalService: GeneralService,
    private userSessionService: UserSessionService) { }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (!event.defaultPrevented && this.currentScript) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.onClickForward();
      }

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        event.preventDefault();
        this.onClickBackward();
      }
    }
  }

  ngOnInit(): void {
    this.getLOVList();
    this.updateScript();
    this.facOpsDataService.scriptIndex$.subscribe(() => {
      this.updateScript();
    });
    this.currentType = this.section || this.facOpsDataService.getCurrentType();
  }

  replaceNewlines(text: string): string {
    return text ? text.replace(/\n/g, '<br>') : '';
  }

  updateScript() {
    this.currentScript = this.facOpsDataService.getScript(this.section);
    this.selectedRoute = this.facOpsDataService.callerScriptParameters.Route;
    this.isFirstScript = this.facOpsDataService.isFirstScript();
    this.isLastScript = this.facOpsDataService.isLastScript();
  }

  getLOVList() {
    if (this.userSessionService.lovList && this.userSessionService.lovList.length) {
      this.prospectTypes = this.userSessionService.getLovListForType(147);
      this.routes = this.userSessionService.getLovListForType(146);
      this.sections = this.userSessionService.getLovListForType(148);
    } else {
      this.generalService.getAllListOfValues().subscribe((response: any) => {
        if (response.length) {
          this.userSessionService.lovList = response;
          this.prospectTypes = this.userSessionService.getLovListForType(147);
          this.routes = this.userSessionService.getLovListForType(146);
          this.sections = this.userSessionService.getLovListForType(148);
        }
      });
    }
  }

  onClickForward() {
    this.facOpsDataService.nextScript();
  }

  onClickBackward() {
    this.facOpsDataService.previousScript();
  }

  getSelectedRoute() {
    this.selectedRoute = this.facOpsDataService.callerScriptParameters.Route;
    return this.selectedRoute;
  }

  isTransactionInitiated() {
    if ((this.currentType == ECallScriptSections.Prospect && !this.facOpsDataService.isFromFollowup && !this.facOpsDataService.isFromScreenPopup)
      || this.currentType == ECallScriptSections.FollowUp || (this.currentType == ECallScriptSections.MatchingContact && this.isScreenPopup)) {
      return true;
    }
    return false;
  }

  onChangeRoute(event) {
    this.facOpsDataService.callerScriptParameters.Route = parseInt(event.target.value, 10);
    this.facOpsDataService.clearCallScriptOnRouteChange();
    this.facOpsDataService.isScriptDataPresent(this.currentType, true, false, this.isScreenPopup)
  }

  disableRouteDropDown() {
    if (this.facOpsDataService.routeDefinedResponse &&
      (this.facOpsDataService.routeDefinedResponse.InBound && this.facOpsDataService.routeDefinedResponse.OutBound)) {
      return false;
    }
    return true;
  }
}
